import { useCallback } from 'react';

import { fetchStatsSettingsAction } from '../apiActions/fetchStatsSettingsAction';
import { useCoreDispatch } from '../CoreStore';
import { useConfigSlice } from '../slices/config/selectors';
import { configActions } from '../slices/config/slice';

export const useStatsSettingsFetcher = (): (() => void) => {
  const dispatch = useCoreDispatch();
  const env = useConfigSlice.env();

  return useCallback(() => {
    if (env) {
      if (env.statsCollector) {
        dispatch(
          fetchStatsSettingsAction({
            url: `${env.statsCollector}`,
          })
        );
      } else {
        // Explicitly dispatch null, meaning config is not available
        dispatch(configActions.setStatsSettings(null));
      }
    }
  }, [dispatch, env]);
};
